import { Injectable } from "@angular/core";
import * as FileSaver from "file-saver";

@Injectable()
export class FileSaverService {
  constructor() {}

  public save = (file: DocumentModel): void => {
    var byteCharacters = atob(file.fileBytes);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var blob = new Blob([new Uint8Array(byteNumbers)], {
      type: file.contentType
    });
    FileSaver.saveAs(blob, file.fileName);
  };
}

export interface DocumentModel {
  contentType: string;
  fileBytes: string;
  fileName: string;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/services/file-saver.service.ts